import './App.css';
import Button from './component/button';
import DirectionMapGoogle from './component/googlemapdirection';
import NotificationCard from './component/notificationcard';
import OrderDetailsCard from './component/orderdetailscard';
import RefreshStatus from './component/refreshstatus';
import DeliveryPartnerCard from './component/deliverypartnercard';
import { sample_data } from './utils/sampleData';
import { useEffect, useRef, useState } from 'react';
import { DELIVERY_STATUS, LIVE_LOCATION_STATUS, PICKUP_STATUS, ROUTE_TARGET, extractLatLng, extractLocationTitle, formatDateAndTime, getAddressObject, makeAddressPara, makeAddressString } from './utils/functionalHelper';
import { TopPromotionalBanner } from './component/promotionalbanner';

import { fireStore } from './utils/firebase/setup';
import { onValue, ref } from "firebase/database";
import { InputModal } from './component/inputform';
import { END_POINTS, RequestData } from './utils/apiService';
import ButtonFor3Pl from './component/buttonfor3pl';
import EstimatedTime from './component/estimatedtime';
import Deliveryratings from './component/deliveryratings';

function App() {
  const [loadingOrder, setLoadingOrder] = useState(false);
  const [orderDetails, setOrderDetails] = useState(sample_data?.order);
  const [shipmentDetails, setShipmentDetails] = useState(sample_data?.shipment);
  const [shipmentFeedback, setShipmentFeedback] = useState([]);
  // const customerData = getAddressObject((sample_data?.order?.shipping_address), (sample_data?.order?.billing_address));
  // const customerLinerData = (makeAddressString(customerData));
  // const customerAddressPara = (makeAddressPara(customerData));
  // const deliveryAssignee = (sample_data?.assigned_to);
  // const promotionBanners = (sample_data?.tracking_module?.promotion_banner);
  const [customerData, setCustomerData] = useState('');
  const [customerLinerData, setCustomerLinerData] = useState('');
  const [customerAddressPara, setCustomerAddressPara] = useState('');
  const [deliveryAssignee, setDeliveryAssignee] = useState('');
  const [promotionBanners, setPromotionBanners] = useState('');

  const [warehouseGeoCoordinates, setWarehouseGeoCoordinates] = useState('');
  const [warehouseTitle, setWarehouseTitle] = useState('');
  const [deliveryPointGeoCoordinates, setDeliveryPointGeoCoordinates] = useState('');

  const [assigneeGeoCoordinates, setAssigneeGeoCoordinates] = useState();
  const [assigneeGeoCoordinatesAvailable, setAssigneeGeoCoordinatesAvailable] = useState(false);
  const [estimatedDeliveryTime, setEstimatedDeliveryTime] = useState('');
  const [assigneeLocationLastUpdatedAt, setAssigneeLocationLastUpdatedAt] = useState('');
  const [orderNextDayProcessMessage, setOderNextDayProcessMessage] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);

  const query = new URLSearchParams(window.location.search);
  const unsubscribeAssigneeLocation = useRef(null);

  const fetchAssigneeLocationData = async (assigned_to) => {
    try {
      if (assigned_to?._id) {
        const query = ref(fireStore, "live-location/" + assigned_to?._id);
        // const query = ref(fireStore, "live-location/639194f9751d66c59f50a7c8");
        unsubscribeAssigneeLocation.current = onValue(query, (snapshot) => {
          const data = snapshot.val();

          if (snapshot.exists()) {
            // Object.values(data).map((project) => {
            // console.log('snapshot_data', data)
            if ((data?.latitude) && (data?.longitude)) {
              let lat = parseFloat(data?.latitude);
              let lng = parseFloat(data?.longitude);
              if (lat && lng) {
                let coo_obj = { lat: lat, lng: lng };
                setAssigneeGeoCoordinates(coo_obj);
                setAssigneeGeoCoordinatesAvailable(true);
                setAssigneeLocationLastUpdatedAt(new Date(data?.updated_at));
              }

            }
          }
          else {
            setAssigneeGeoCoordinatesAvailable(false);
            console.log('Assignee is off-line')
          }
        });
        return unsubscribeAssigneeLocation.current;
      }
      else {
        console.log('Assignee id not available');
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  const fetchOrderData = ({ tracking_id, awb, order_number, email_address }) => {
    setLoadingOrder(true);
    try {
      let payloads = '';
      if (tracking_id) {
        payloads = { "tracking_id": tracking_id };
      }
      else if (awb) {
        payloads = { "awb_number": awb }
      }
      else if (email_address && order_number) {
        payloads = { "order_name": order_number, "customer_email": email_address }
      }

      RequestData(END_POINTS?.TRACKING_URL, 'POST', payloads).then((response) => {
        // console.log("🚀 ~ RequestData ~ order_details:", response?.data);
        if (response?.status && (response?.data?.length)) {
          const data = response?.data[0];
          // const data = sample_data;
          setOrderDetails(data?.order);
          const shipment_details = (data?.shipment);
          extractGeoCoordinates(shipment_details, (data?.assigned_to));
          setShipmentDetails(shipment_details);
          setShipmentFeedback(data?.shipment_feedback);

          setDeliveryAssignee(data?.assigned_to);
          setPromotionBanners([{ image_url: 'https://homerun.page.link/tzH3' }]);
          // setPromotionBanners(data?.tracking_module?.promotion_banner);
          const customer_data = getAddressObject((data?.order?.shipping_address), (data?.order?.billing_address));
          // console.log("🚀 ~ RequestData ~ customer_data:", customer_data)
          setCustomerData(customer_data);
          setCustomerLinerData(makeAddressString(customer_data));
          setCustomerAddressPara(makeAddressPara(customer_data));
        } else {
          window.close();
        }
      })
    } catch (err) {
      setLoadingOrder(false);
      console.log(err);
    }
  }


  const extractGeoCoordinates = (shipmentDetails_, deliveryAssignee_) => {
    // The driver's live location is shown from the moment they are assigned -
    // while they are on their way to our store as well as once the order is
    // out for delivery.
    if (LIVE_LOCATION_STATUS.includes(shipmentDetails_?.shipment_status) && (deliveryAssignee_?._id)) {
      fetchAssigneeLocationData(deliveryAssignee_);
    }
    const deliveryPoint = extractLatLng(shipmentDetails_?.end_location);
    if (deliveryPoint) {
      setDeliveryPointGeoCoordinates(deliveryPoint);
    }

    // The store the driver picks the order up from. Its coordinates sit on the
    // populated start_location.shipment_location ref (or the normalised
    // start_location.display), never inline the way the customer's do.
    const storePoint = extractLatLng(shipmentDetails_?.start_location);
    if (storePoint) {
      setWarehouseGeoCoordinates(storePoint);
      setWarehouseTitle(extractLocationTitle(shipmentDetails_?.start_location));
    }
    setLoadingOrder(false);
  }

  useEffect(() => {
    let awb = '';
    let order_number = '';
    let email_address = '';
    const tracking_id = query.get('tracking_id');
    const current_url = (window.location.href);
    const match = current_url.match(/awb\/([^/]+)/);
    if (match) {
      awb = match[1];
      // console.log(awb);
    } else {
      order_number = query.get('order_number');
      email_address = query.get('email_address');
    }

    fetchOrderData({ tracking_id, awb, order_number, email_address });

    return () => {
      if (unsubscribeAssigneeLocation.current) {
        unsubscribeAssigneeLocation.current();
      }
    };

  }, [])

  // Until the order is picked up the driver is driving towards our store, so
  // the map routes there; after that they are driving towards the customer.
  const isDriverHeadingToStore = (Boolean(deliveryAssignee?._id) && PICKUP_STATUS.includes(shipmentDetails?.shipment_status));
  const routeTarget = isDriverHeadingToStore ? ROUTE_TARGET.WAREHOUSE : ROUTE_TARGET.CUSTOMER;

  if (deliveryAssignee?.first_name === "3") {
    return (
      <div className="se-flex se-justify-center se-items-center se-h-fit se-overflow-auto se-min-h-screen">
        {(!loadingOrder) ?
          <div className="se-w-full se-my-0 se-max-w-[1000px] se-bg-white se-m-auto se-box-border se-rounded-lg desktop-shadow">
            <div className="se-w-full se-my-0 md:se-pb-8 md:se-my-8 se-max-w-[1000px] se-bg-white se-m-auto se-box-border se-rounded-lg desktop-shadow">
              <div className='se-mr-auto se-ml-auto se-w-full md:se-mb-8'>
                <TopPromotionalBanner promotionBanners={promotionBanners} />
              </div>
              <div className='se-w-full se-flex se-flex-col md:se-flex-row md:se-justify-around se-gap-5'>
                <div className='se-flex se-flex-col se-gap-5 md:se-max-w-[400px]'>
                  <div className='md:se-w-[400px]'>
                    {[DELIVERY_STATUS?.DELIVERED, DELIVERY_STATUS?.CANCELLED].includes(shipmentDetails?.shipment_status) ?
                      <DirectionMapGoogle
                        containerWidth="100%"
                        containerHeight="30vh"
                        warehouse={warehouseGeoCoordinates}
                        warehouseTitle={warehouseTitle}
                        assigneeGeoCoordinatesAvailable={assigneeGeoCoordinatesAvailable}
                        origin={assigneeGeoCoordinates}
                        destination={deliveryPointGeoCoordinates}
                        status={shipmentDetails?.shipment_status}
                        routeTarget={routeTarget}
                        setEstimatedDeliveryTime={setEstimatedDeliveryTime}
                      />
                      :
                      <img width="100%" src="/images/3pl.png" alt="shipped via 3pl" />}
                  </div>
                  <div className='se-px-4 se-flex se-flex-col se-gap-5'>

                    {((shipmentDetails?.shipment_status) === DELIVERY_STATUS?.NEW && (deliveryAssignee?._id)) &&
                      <ButtonFor3Pl status={shipmentDetails?.shipment_status} text="Packing Your Order" />
                    }

                    {((shipmentDetails?.shipment_status) === DELIVERY_STATUS?.PICKED_UP && (deliveryAssignee?._id)) &&
                      <ButtonFor3Pl status={shipmentDetails?.shipment_status} text="Order Packed" />
                    }

                    {(shipmentDetails?.shipment_status === DELIVERY_STATUS?.OUT_FOR_DELIVERY) && (deliveryAssignee?._id) &&
                      <ButtonFor3Pl status={shipmentDetails?.shipment_status} text="Order is on the way" />
                    }

                    {DELIVERY_STATUS?.CANCELLED === (shipmentDetails?.shipment_status) &&
                      <ButtonFor3Pl status={shipmentDetails?.shipment_status} text="Order Cancelled" />
                    }

                    {DELIVERY_STATUS?.DELIVERED === (shipmentDetails?.shipment_status) &&
                      <ButtonFor3Pl status={shipmentDetails?.shipment_status} text="Order Delivered" />
                    }

                    {DELIVERY_STATUS?.PARTIAL_DELIVERED === (shipmentDetails?.shipment_status) &&
                      <ButtonFor3Pl status={shipmentDetails?.shipment_status} text="Order Delivered" />
                    }

                    {[DELIVERY_STATUS?.DELIVERED, DELIVERY_STATUS?.PARTIAL_DELIVERED].includes(shipmentDetails?.shipment_status) &&
                      <Deliveryratings shipmentDetails={shipmentDetails}
                        isEditable={!shipmentFeedback?.rating} initialRating={shipmentFeedback?.rating} initialFeedback={shipmentFeedback?.notes}
                      />}


                    {(shipmentDetails?.shipment_status === DELIVERY_STATUS?.RESCHEDULE) ?
                      <RefreshStatus text={`Your order has been rescheduled ${new Date(shipmentDetails?.reschedule_date).toDateString()}`} /> :
                      (shipmentDetails?.shipment_status !== DELIVERY_STATUS?.DELIVERED) &&
                      <RefreshStatus />
                    }
                  </div>
                </div>

                <div style={{ backgroundColor: "#FCFAF4" }} className="se-max-w-full se-bg-[#FCFAF4] md:se-max-w-[400px] md:se-mx-0 se-bg-white se-px-5 se-box-border se-rounded-lg se-shadow-md">
                  <OrderDetailsCard
                    order_details={orderDetails?.name}
                    order_date_time={formatDateAndTime(orderDetails?.created_at)}
                    customer_name={customerLinerData?.name}
                    customer_phone={customerData?.phone || (orderDetails?.customer?.phone)}
                    customer_address={customerAddressPara}
                  />
                </div>
              </div>

              <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <InputModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
              </div>
            </div>
          </div>
          :
          <TruckLoader />
        }
      </div>
    );
  }
  else {
    return (
      <div className="se-flex se-justify-center se-items-center se-h-fit se-overflow-auto se-min-h-screen">
        {/* <div className="se-w-full se-my-0 se-py-8 md:se-my-8 se-max-w-[900px] se-bg-white se-m-auto se-box-border se-rounded-lg se-shadow-md se-shadow-blue-50"> */}
        {/* <div className="se-w-full se-my-0 md:se-py-8 md:se-my-8 se-max-w-[900px] se-bg-white se-m-auto se-box-border se-rounded-lg se-shadow-md se-shadow-blue-50"> */}
        {/* <div className="se-w-full se-my-0 md:se-py-8 md:se-my-8 se-max-w-[900px] se-bg-white se-m-auto se-box-border se-rounded-lg md:se-shadow-lg md:se-shadow-gray-300"> */}
        {!loadingOrder ? (
          <div className="se-w-full se-my-0 md:se-pb-8 md:se-my-8 se-max-w-[1000px] se-bg-white se-m-auto se-box-border se-rounded-lg desktop-shadow">
            <div className='se-mr-auto se-ml-auto se-w-full md:se-mb-8'>
              <TopPromotionalBanner promotionBanners={promotionBanners} />
            </div>
            <div className='se-w-full se-flex se-flex-col md:se-flex-row md:se-justify-around se-gap-5'>
              <div className='se-flex se-flex-col se-gap-5 md:se-max-w-[400px]'>
                <div className='md:se-w-[400px]'>
                  <DirectionMapGoogle
                    containerWidth="100%"
                    containerHeight="30vh"
                    warehouse={warehouseGeoCoordinates}
                    warehouseTitle={warehouseTitle}
                    assigneeGeoCoordinatesAvailable={assigneeGeoCoordinatesAvailable}
                    origin={assigneeGeoCoordinates}
                    destination={deliveryPointGeoCoordinates}
                    status={shipmentDetails?.shipment_status}
                    routeTarget={routeTarget}
                    setEstimatedDeliveryTime={setEstimatedDeliveryTime}
                  />
                </div>
                <div className='se-px-4 se-flex se-flex-col se-gap-5'>

                  {(DELIVERY_STATUS?.NEW === (shipmentDetails?.shipment_status) && (!deliveryAssignee?._id)) &&
                    <Button status={shipmentDetails?.shipment_status} text="We'll assign a delivery partner soon"
                      time_conditional orderDetails={orderDetails}
                      setOderNextDayProcessMessage={setOderNextDayProcessMessage}
                    />}

                  {(DELIVERY_STATUS?.NEW === (shipmentDetails?.shipment_status) && (deliveryAssignee?._id)) &&
                    <NotificationCard
                      imgUrl={(deliveryAssignee?.profile_image) || "/images/home_run_icon.jpeg"}
                      name={((deliveryAssignee?.first_name) || "Driver")}
                      status={shipmentDetails?.shipment_status}
                      textColor="se-yellow-800"
                      text={`${(deliveryAssignee?.first_name) || "Driver"} is reaching our store to pick your order`}
                    />
                  }

                  {(DELIVERY_STATUS?.PICKED_UP === (shipmentDetails?.shipment_status) && (deliveryAssignee?._id)) &&
                    <NotificationCard
                      imgUrl={(deliveryAssignee?.profile_image) || "/images/home_run_icon.jpeg"}
                      name={((deliveryAssignee?.first_name) || "Driver")}
                      status={shipmentDetails?.shipment_status}
                      textColor="se-yellow-800"
                      text={`${(deliveryAssignee?.first_name) || "Driver"} is reaching our store to pick your order`}
                    />
                  }

                  {(shipmentDetails?.shipment_status === "OUT_FOR_DELIVERY") && <>
                    {/* <DeliveryPartnerCard name={(deliveryAssignee?.first_name || "Delivery") + ' ' + (deliveryAssignee?.last_name || "Executive")} contactNumber={deliveryAssignee?.phone || ""} /> */}
                    <NotificationCard
                      imgUrl={(deliveryAssignee?.profile_image) || "/images/home_run_icon.jpeg"}
                      name={((deliveryAssignee?.first_name) || "Driver")}
                      status={shipmentDetails?.shipment_status}
                      textColor="se-gray-800"
                      text={`${(deliveryAssignee?.first_name) || "Driver"} is on the way to your location`}
                      contactNumber={deliveryAssignee?.phone || ""}
                    />
                  </>}

                  {DELIVERY_STATUS?.CANCELLED === (shipmentDetails?.shipment_status) &&
                    <Button status={shipmentDetails?.shipment_status} text="Order Cancelled" />
                  }

                  {DELIVERY_STATUS?.DELIVERED === (shipmentDetails?.shipment_status) &&
                    <Button status={shipmentDetails?.shipment_status} text="Order Delivered" />
                  }

                  {DELIVERY_STATUS?.PARTIAL_DELIVERED === (shipmentDetails?.shipment_status) &&
                    <Button status={shipmentDetails?.shipment_status} text="Order Delivered" />
                  }
                  {[DELIVERY_STATUS?.DELIVERED, DELIVERY_STATUS?.PARTIAL_DELIVERED].includes(shipmentDetails?.shipment_status) &&
                    <Deliveryratings shipmentDetails={shipmentDetails}
                      isEditable={!shipmentFeedback?.rating} initialRating={shipmentFeedback?.rating} initialFeedback={shipmentFeedback?.notes}
                    />}
                  {orderNextDayProcessMessage &&
                    <div className="se-flex se-items-center se-justify-center se-gap-2 se-rounded-md">
                      <span className="se-text-sm se-font-medium">{orderNextDayProcessMessage}</span>
                    </div>
                  }

                  {(isDriverHeadingToStore && estimatedDeliveryTime) &&
                    <EstimatedTime eta={estimatedDeliveryTime} label="Reaching our store in" />
                  }

                  {
                    (estimatedDeliveryTime && shipmentDetails?.shipment_status === DELIVERY_STATUS?.OUT_FOR_DELIVERY) ?
                      <EstimatedTime eta={estimatedDeliveryTime} /> :
                    (shipmentDetails?.shipment_status === DELIVERY_STATUS?.RESCHEDULE) ?
                      <RefreshStatus text={`Your order has been rescheduled ${new Date(shipmentDetails?.reschedule_date).toDateString()}`} /> :
                      (shipmentDetails?.shipment_status !== DELIVERY_STATUS?.DELIVERED) &&
                      <RefreshStatus />
                  }
                </div>
              </div>

              <div style={{ backgroundColor: "#FCFAF4" }} className="se-max-w-full se-bg-[#FCFAF4] md:se-max-w-[400px] md:se-mx-0 se-bg-white se-px-5 se-box-border se-rounded-lg se-shadow-md">
                <OrderDetailsCard
                  order_details={orderDetails?.name}
                  order_date_time={formatDateAndTime(orderDetails?.created_at)}
                  customer_name={customerLinerData?.name}
                  customer_phone={customerData?.phone || (orderDetails?.customer?.phone)}
                  customer_address={customerAddressPara}
                />
              </div>
            </div>

            <div className="flex items-center justify-center min-h-screen bg-gray-100">

              <InputModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
            </div>
          </div>
        )
          :
          <TruckLoader />
        }
      </div>
    );
  }
}

export default App;


const TruckLoader = () => {
  return (<div>
    <style jsx="true">
      {`
    .truck {
      --dur: 3s;
      display: block;
      width: 12em;
      height: auto;
    }

    .truck__body,
    .truck__line,
    .truck__outside1,
    .truck__outside2,
    .truck__outside3,
    .truck__wheel,
    .truck__wheel-spin,
    .truck__window1,
    .truck__window2 {
      animation: truck-body var(--dur) linear infinite;
    }

    .truck__body {
      transform-origin: 17px 11px;
    }

    .truck__line {
      animation-name: truck-line;
    }

    .truck__outside1 {
      animation-name: truck-outside1;
    }

    .truck__outside2 {
      animation-name: truck-outside2;
    }

    .truck__outside3 {
      animation-name: truck-outside3;
    }

    .truck__wheel {
      animation-name: truck-wheel;
    }

    .truck__wheel-spin {
      animation-name: truck-wheel-spin;
      transform-origin: 6.5px 17px;
    }

    .truck__wheel:nth-child(2) {
      animation-delay: calc(var(--dur) * 0.0625);
    }

    .truck__wheel:nth-child(2) .truck__wheel-spin {
      transform-origin: 27px 17px;
    }

    .truck__window1 {
      animation-name: truck-window1;
    }

    .truck__window2 {
      animation-name: truck-window2;
    }

    /* Dark theme */
    @media (prefers-color-scheme: dark) {
      :root {
        --bg: hsl(var(--hue), 90%, 10%);
        --fg: hsl(var(--hue), 90%, 50%);
      }
    }

    /* Animations */
    @keyframes truck-body {
      from,
      12.5%,
      25%,
      37.5%,
      50%,
      62.5%,
      75%,
      87.5%,
      to {
        animation-timing-function: ease-in;
        transform: translate(0, 0) rotate(0);
      }
      6.25%,
      18.75%,
      31.25%,
      43.75%,
      56.25%,
      68.75%,
      81.25%,
      93.75% {
        animation-timing-function: ease-out;
        transform: translate(0, 1px) rotate(-0.75deg);
      }
    }

    @keyframes truck-line {
      from {
        stroke-dashoffset: -18;
      }
      to {
        stroke-dashoffset: 78;
      }
    }

    @keyframes truck-outside1 {
      from {
        stroke-dashoffset: 105;
      }
      to {
        stroke-dashoffset: -105;
      }
    }

    @keyframes truck-outside2 {
      from {
        stroke-dashoffset: 168;
      }
      to {
        stroke-dashoffset: -42;
      }
    }

    @keyframes truck-outside3 {
      from {
        stroke-dashoffset: 192;
      }
      to {
        stroke-dashoffset: -18;
      }
    }

    @keyframes truck-wheel {
      from,
      12.5%,
      25%,
      37.5%,
      50%,
      62.5%,
      75%,
      87.5%,
      to {
        animation-timing-function: ease-in;
        transform: translate(0, 0);
      }
      6.25%,
      18.75%,
      31.25%,
      43.75%,
      56.25%,
      68.75%,
      81.25%,
      93.75% {
        animation-timing-function: ease-out;
        transform: translate(0, -1px);
      }
    }

    @keyframes truck-wheel-spin {
      from {
        stroke-dashoffset: -15.71;
        transform: rotate(0);
      }
      to {
        stroke-dashoffset: 15.71;
        transform: rotate(-4turn);
      }
    }

    @keyframes truck-window1 {
      from {
        stroke-dashoffset: -21;
      }
      to {
        stroke-dashoffset: 189;
      }
    }

    @keyframes truck-window2 {
      from {
        stroke-dashoffset: -39;
      }
      to {
        stroke-dashoffset: 171;
      }
    }
  `}
    </style>

    <svg className="truck" viewBox="0 0 48 24" width="48px" height="24px">
      <g fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" transform="translate(0,2)">
        <g className="truck__body">
          <g strokeDasharray="105 105">
            <polyline className="truck__outside1" points="2 17,1 17,1 11,5 9,7 1,39 1,39 6" />
            <polyline className="truck__outside2" points="39 12,39 17,31.5 17" />
            <polyline className="truck__outside3" points="22.5 17,11 17" />
            <polyline className="truck__window1" points="6.5 4,8 4,8 9,5 9" />
            <polygon className="truck__window2" points="10 4,10 9,14 9,14 4" />
          </g>
          <polyline className="truck__line" points="43 8,31 8" strokeDasharray="10 2 10 2 10 2 10 2 10 2 10 26" />
          <polyline className="truck__line" points="47 10,31 10" strokeDasharray="14 2 14 2 14 2 14 2 14 18" />
        </g>
        <g strokeDasharray="15.71 15.71">
          <g className="truck__wheel">
            <circle className="truck__wheel-spin" r="2.5" cx="6.5" cy="17" />
          </g>
          <g className="truck__wheel">
            <circle className="truck__wheel-spin" r="2.5" cx="27" cy="17" />
          </g>
        </g>
      </g>
    </svg>
    <div style={{ textAlign: 'center' }}> Loading...</div>
  </div>)
}